import { render, staticRenderFns } from "./ChangePhoneNumber.vue?vue&type=template&id=7492605e&scoped=true&"
import script from "./ChangePhoneNumber.vue?vue&type=script&lang=ts&"
export * from "./ChangePhoneNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7492605e",
  null
  
)

export default component.exports